import { Vue, Component, Prop } from "vue-property-decorator";
import moment from "moment";
import { Action, Getter } from "vuex-class";

// External components
import CollapsibleContent from "../collapsibleContent/collapsibleContent";
import ModalCoupon from "../modalCoupon/modalCoupon";
import OrderPreviewHeader from "../subscriptionOrders/OrderPreviewHeader/OrderPreviewHeader";

// Helpers
import { localCurrency } from "@/plugins/currency";
import {
  orderStatusToSpanish,
  subscriptionStatusToSpanish,
  isOrderInTerminalStatus,
  getMenuPriceByMenuId,
} from "@/plugins/subscriptions_helper";

@Component({
  methods: {
    localCurrency,
    moment,
    getMenuPriceByMenuId,
  },
  components: {
    CollapsibleContent,
    ModalCoupon,
    OrderPreviewHeader,
  },
})
export default class DashboardOrderSummary extends Vue {
  @Prop({ default: null }) order;
  @Prop({ default: false }) isLastOrder: boolean;

  @Action action_getMenus;

  @Getter getUser;
  @Getter getCurrentOrder;
  @Getter getMenus;
  @Getter getCity;
  @Getter getIsUnderMobile;
  @Getter getMenuPrices;

  selectedAddress = null;
  isShowingCouponModal = false;

  async mounted() {
    if (!this.isLastOrder) {
      const { addresses } = this.getUser;
      this.selectedAddress = addresses.find((address) => address.id === this.order.address_id);
    } else {
      this.selectedAddress = { address: this.order.address, address_info: this.order.address_info };
    }
  }

  getMenuDetailsById(menuId: number) {
    return this.order.details_subscription_menus.find((menu) => menu.menu_id === menuId);
  }

  paymentMethodToSpanish = (paymentMethod: string) => {
    if (paymentMethod === "cash") return "Efectivo";
    if (paymentMethod === "credit_card") return "Tarjeta de crédito";
    if (paymentMethod === "datafono") return "Datáfono";
    if (paymentMethod === "payment_link") return "Link de pagos";
  };

  toLocalCurrency(value: string) {
    return localCurrency(value);
  }

  get getOrderStatus() {
    if (this.isLastOrder) return orderStatusToSpanish(this.order.status);
    return subscriptionStatusToSpanish(this.order);
  }

  get getSkipedWeekDealDate() {
    return moment(this.order.deal_date).add(-7, "day");
  }

  get isLastOrderInTerminalStatus() {
    if (!this.getCurrentOrder) return true;
    return isOrderInTerminalStatus(this.getCurrentOrder);
  }

  get isLastOrderOverPrice() {
    return (
      this.isLastOrder &&
      this.order.subscription_extra_fields &&
      this.order.subscription_extra_fields.overprice &&
      this.order.subscription_extra_fields.overprice !== "0.0"
    );
  }
}
